import { TotemIconId } from '@meilleurtaux/mtp-uikit-core';

import { STATUS } from '@/enums/status';

const STATUS_ICON_NOTIFICATION: Record<STATUS, TotemIconId> = {
  [STATUS.INFO]: 'info-circle-solid',
  [STATUS.WARNING]: 'warning-solide',
  [STATUS.SUCCESS]: 'check-circle-solid',
  [STATUS.ERROR]: 'cross-circle-solid',
};

export { STATUS_ICON_NOTIFICATION };
